import Current from "./Current";
import Item from "./Item";
import List from "./List";
import Root from "./Root";
import Separator from "./Separator";

export const Breadcrumb = {
  Root,
  List,
  Item,
  Current,
  Separator,
};
